import {Moment} from 'moment'
import * as React from 'react'
import {ReactElement} from 'react'
import {NatPostDisasterCommentForAdminRequest} from '../repository/NatPostDisasterCommentForAdmin'
import {NatPostDisasterCommentFileUploadRequest} from '../repository/NatPostDisasterCommentFileUpload'
import {Nullable} from '../../../../app/TypeHelpers'
import {NatPutDisasterCommentForAdminRequest} from '../repository/NatPutDisasterCommentForAdmin'
import {Comment, CommentInfo} from '../repository/NatGetDisasterCommentForAdmin'
import {MESSAGE_TYPE, YES_OR_NOT} from '../../../../CodeMaster'
import {Messages} from '../../../../Messages'
import {Colors} from '../../../../styledComponents/Constants'
import NatAdminDisasterCommentItem from './NatAdminDisasterCommentItem'
import {DeleteAlertIcon} from '../../../../styledComponents/adminPage/IconCreator'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {InputError} from './NatAdminDisasterCommentError'
import {ImageViewDialogForAdmin} from './NatDisasterImageViewDialogForAdmin'

interface Props {
    condominiumCd: string
    topicId: number
    CommentInfoList: CommentInfo[]
    currentDateTime: Moment
    pastFlag: boolean
    onReply: (
        commentRequest: NatPostDisasterCommentForAdminRequest,
        fileRequests: NatPostDisasterCommentFileUploadRequest[]
    ) => Promise<Nullable<InputError>>
    onEdit: (
        commentId: number,
        commentRequest: NatPutDisasterCommentForAdminRequest,
        fileRequests: NatPostDisasterCommentFileUploadRequest[]
    ) => Promise<Nullable<InputError>>
    onDelete: (
        commentId: number
    ) => Promise<void>
    inputError: Nullable<InputError>
    eventEmitter: EventEmitterExAdmin
}

interface State {
    previewStartIndex: number
    targetCommentInfo: Nullable<Comment>
    isPreviewOpen: boolean
}

export default class NatAdminDisasterCommentList extends React.PureComponent<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            previewStartIndex: 0,
            targetCommentInfo: null,
            isPreviewOpen: false
        }
        this.handleDialogCansel = this.handleDialogCansel.bind(this);
    }

    handleDeleteCommentDialogOpen = (comment: Comment): void => {
        this.setState({
            targetCommentInfo: comment
        }, () => this.renderDeleteDialog())
    }

    handlePreviewDialogDialogOpen = (comment: Comment, previewStartIndex: number): void => {
        this.setState({
            isPreviewOpen: true,
            targetCommentInfo: comment,
            previewStartIndex: previewStartIndex
        })
    }

    handleDialogCansel(): void {
        this.setState({
            targetCommentInfo: null,
            previewStartIndex: 0,
            isPreviewOpen: false
        })
        this.props.eventEmitter.closeDialog();
    }

    handleReplyComment = async (
        commentRequest: NatPostDisasterCommentForAdminRequest,
        fileRequests: NatPostDisasterCommentFileUploadRequest[]
    ): Promise<Nullable<InputError>> => {
        return await this.props.onReply(commentRequest, fileRequests)
    }

    handleEditComment = async (
        commentId: number,
        commentRequest: NatPutDisasterCommentForAdminRequest,
        fileRequests: NatPostDisasterCommentFileUploadRequest[]
    ): Promise<Nullable<InputError>> => {
        return await this.props.onEdit(commentId, commentRequest, fileRequests)
    }

    handleDeleteComment = async (): Promise<void> => {
        if (!this.state.targetCommentInfo) {
            return
        }
        const {commentId} = this.state.targetCommentInfo
        await this.props.onDelete(commentId)
        this.handleDialogCansel()
    }

    async renderDeleteDialog(): Promise<void> {
        const message = this.state.targetCommentInfo?.isPosterSelf === YES_OR_NOT.YES.value ?
            Messages.IOPCC0029.toString('コメント') : Messages.IDISC0002.message

        await this.props.eventEmitter.showDialog({
                title: '削除確認',
                titleIcon: <DeleteAlertIcon/>,
                errorLevel: MESSAGE_TYPE.ERROR,
                message: message,
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: '削除する',
                        buttonHandler: this.handleDeleteComment,
                        color: Colors.Alert
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleDialogCansel,
                    },
                ],
            },
        );
    }

    renderPreviewDialog(): ReactElement {
        if (!this.state.targetCommentInfo) {
            return <></>
        }

        const {commentToAttachment} = this.state.targetCommentInfo

        const images = commentToAttachment.map(file => {
            return {
                original: file.PreviewLargePath
            }
        })

        return (
            <ImageViewDialogForAdmin
                open={this.state.isPreviewOpen}
                images={images}
                onClose={this.handleDialogCansel}
                startIndex={this.state.previewStartIndex}
            />
        )
    }

    render(): ReactElement {
        const {CommentInfoList, pastFlag, inputError, currentDateTime} = this.props

        return (
            <>
                {this.renderPreviewDialog()}
                {CommentInfoList.length === 0 &&
                    <div>
                        投稿がありません。
                    </div>
                }
                {CommentInfoList.map((commentInfo) =>
                    <NatAdminDisasterCommentItem
                        key={commentInfo.commentId}
                        commentInfo={commentInfo}
                        currentDateTime={currentDateTime}
                        pastFlag={pastFlag}
                        onClickReplyButton={this.handleReplyComment}
                        onClickEditButton={this.handleEditComment}
                        onClickDeleteButton={this.handleDeleteCommentDialogOpen}
                        onClickPreviewButton={this.handlePreviewDialogDialogOpen}
                        inputError={inputError}
                    />
                )}
            </>
        )
    }
}
